<template>
    <v-dialog
        v-model="drawer"
        :width="drawerWidth"
        scrollable
        transition="none"
        content-class="rounded-0 drawer"
    >
        <v-card class="rounded-0">
            <v-card-title class="pa-0">
                <slot name="drawerTitle"></slot>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
                <slot name="drawerBody"></slot>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-0">
                <slot name="drawerActions"></slot>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "RightDrawer",

    props: {
        showDrawer: {
            type: Boolean,
            required: true,
        },
        drawerWidth: {
            type: String,
            default: '500px',
        },
    },

    data: () => ({
        drawer: false,
    }),

    watch: {
        showDrawer: function() {
            this.drawer = !this.drawer;
        },
    }
}
</script>

<style scoped>
>>> .drawer {
    max-height: 100vh;
    height: 100vh;
    margin: 0;
    transition: transform 0.5s;
}

>>> .none-enter-to {
    transform: translateX(0px);
}

>>> .none-enter-active {
    transform: translateX(100%);
}

>>> .none-leave-active {
    transform: translateX(100%);
}

.v-dialog__content {
    justify-content: flex-end;
    border-radius: 0;
}
</style>
